import './App.scss';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Navbar from "./navbar/navbar";
import About from "./pages/about/about";
import Movies from "./pages/movies/movies";
import React, { ReactElement, Suspense } from "react";
import Footer from "./footer/footer";
import FilmOutlet from "./pages/movies/filmOutlet/filmOutlet";
import ScrollToTop from "./assets/scrollToTop";
import LoadingScreen from "./pages/shared/loadingScreen";
import Contact from "./pages/contact/contact";
import PageNotFound from "./pages/shared/pageNotFound";
import { Analytics } from "@vercel/analytics/react"

import "./App.scss"
import Music from "./pages/music/music";
import Home from "./pages/home/home";


export default function App(): ReactElement {
  return (
    <Suspense fallback={<LoadingScreen/>}>
      <BrowserRouter>
        <div className="d-flex flex-column min-vh-100">
          <Navbar/>
          <ScrollToTop/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/movies" element={<Movies/>}/>
            <Route path="/movies/:movieName" element={<FilmOutlet/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/music" element={<Music/>}/>
            <Route path="*" element={<PageNotFound/>}/>
          </Routes>
          <Footer/>
          <Analytics />
        </div>
      </BrowserRouter>
    </Suspense>
  );
}
